'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';

// This is a client component that wraps the SessionProvider from NextAuth
// It allows client components to access session data using useSession()
export default function SessionProvider({
  children,
  session
}: {
  children: ReactNode;
  session: any;
}) {
  return (
    <NextAuthSessionProvider session={session}>
      {children}
    </NextAuthSessionProvider>
  );
} 